import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    deviceData: null,
    deviceIds: []
  },
  mutations: {
    SET_DEVICE_DATA(state, data) {
      state.deviceData = data;
    },
    SET_DEVICE_IDS(state, ids) {
      state.deviceIds = ids;
    }
  },
  actions: {
  },
  modules: {
  }
})